<template>
<card>
    <base-dropdown direction="up" class="drop">
        <template #title-container><h4 class="dropdown-toggle"> {{forums[selectedIndex].name}} </h4></template>
        <li v-for="(forum, i) in forums" :key="i" @click="selectedIndex = i">
            {{ forum.name }}
        </li>
    </base-dropdown>
    <Forum name="forum top" container :forum="{id: forums[selectedIndex].id}"/>
</card>
</template>

<script>
import Card from '../../../../argon/components/Cards/Card';
import BaseDropdown from '../../../../argon/components/BaseDropdown';
import Forum from '../../../Forum';

export default {
    name: 'OptionsForum',
    components: {
        BaseDropdown,
        Card,
        Forum,
    },
    props: {
        forum: Object,
        name: String,
    },
    data() {
        return {
            forums: [
                {
                    name: this.name,
                    id: this.forum.id,
                },
            ],
        };
    },
    computed: {
        selectedIndex: {
            get() {
                for (let i = 0; i < this.forums.length; i += 1) {
                    if (this.forums[i].selected) return i;
                }
                return 0;
            },
            set(value) {
                // more ao eslint no-param-reassign
                const copy = [];
                this.forums.map(forum => copy.push({ ...forum, selected: false }));
                this.forums = copy;
                this.forums[value].selected = true;
            },
        },
    },
};
</script>

<style lang="sass" scoped>
.drop
    padding: 10px 15px
    margin: 8px
    li
        margin: 6px
        padding: 6px 4px
        cursor: pointer
        background-color: white
        transition: all .35s
        &:hover
            filter: brightness(94%)
</style>
